import arrowRight from '@ingka/ssr-icon/paths/arrow-right';
import checkmark from '@ingka/ssr-icon/paths/checkmark';
import checkmarkCircle from '@ingka/ssr-icon/paths/checkmark-circle';
import checkmarkCross from '@ingka/ssr-icon/paths/cross-circle';
import crossSmall from '@ingka/ssr-icon/paths/cross-small';
import flag from '@ingka/ssr-icon/paths/flag';
import imageStrikethrough from '@ingka/ssr-icon/paths/image-strikethrough';
import linkOut from '@ingka/ssr-icon/paths/link-out';
import noticeCircle from '@ingka/ssr-icon/paths/notice-circle';
import sparkles from '@ingka/ssr-icon/paths/clean-sparkles';
import magnifyingGlassList from '@ingka/ssr-icon/paths/magnifying-glass-list';
import documentCheckmark from '@ingka/ssr-icon/paths/document-checkmark';
import squareGrid from '@ingka/ssr-icon/paths/square-grid-3x3-filled';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import hourglass from '@ingka/ssr-icon/paths/hourglass';
import CodeIcon from '@mui/icons-material/Code';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';
import { McpIcon } from '../AllenMcp/icons/McpIcon';
import megaphoneIcon from '@ingka/ssr-icon/paths/megaphone';
import informationCircle from '@ingka/ssr-icon/paths/information-circle';
import warningTriangle from '@ingka/ssr-icon/paths/warning-triangle';
import { IconType } from './types';

const iconMapping = {
  arrowRight: { type: IconType.SSR, component: arrowRight },
  checkmark: { type: IconType.SSR, component: checkmark, color: '#0A8A00' },
  crossSmall: { type: IconType.SSR, component: crossSmall, color: '#E00751' },
  approve: {
    type: IconType.SSR,
    component: checkmarkCircle,
    color: '#0A8A00',
  },
  deny: {
    type: IconType.SSR,
    component: checkmarkCross,
    color: '#E00751',
  },
  pending: {
    type: IconType.SSR,
    component: hourglass,
    color: '#f26a2f',
  },
  notice: {
    type: IconType.SSR,
    component: noticeCircle,
    color: '#0158a3',
  },
  flag: { type: IconType.SSR, component: flag },
  imageStrikethrough: { type: IconType.SSR, component: imageStrikethrough },
  linkOut: { type: IconType.SSR, component: linkOut },
  sparkles: { type: IconType.SSR, component: sparkles },
  magnifyingGlassList: { type: IconType.SSR, component: magnifyingGlassList },
  documentCheckmark: { type: IconType.SSR, component: documentCheckmark },
  squareGrid: { type: IconType.SSR, component: squareGrid },
  manageAccounts: { type: IconType.MUI, component: ManageAccountsIcon },
  code: { type: IconType.MUI, component: CodeIcon },
  download: { type: IconType.MUI, component: DownloadIcon },
  mcp: { type: IconType.MUI, component: McpIcon },
  announcement: {
    type: IconType.SSR,
    component: megaphoneIcon,
    color: 'var(--bui-bg-solid)',
  },
  // Notification severity fallbacks (used when a payload has no icon)
  critical: {
    type: IconType.SSR,
    component: noticeCircle,
    color: 'var(--bui-fg-danger)',
  },
  high: {
    type: IconType.SSR,
    component: warningTriangle,
    color: 'var(--bui-fg-warning)',
  },
  info: {
    type: IconType.SSR,
    component: informationCircle,
    color: 'var(--bui-bg-solid)',
  },
} as const;

export default iconMapping;
